export enum PERMISSION {
  manageAllSectionChangeRequests = "manageAllSectionChangeRequests",
  manageOwnSectionChangeRequests = "manageOwnSectionChangeRequests",
  manageOwnSectionChangeRequestSettings = "manageOwnSectionChangeRequestSettings",
  viewMemberContributions = "viewMemberContributions",
  viewSponsorContributions = "viewSponsorContributions",
  viewGrpEnrollments = "viewGrpEnrollments",
  viewOrders = "viewOrders",
  viewPayments = "viewPayments",
  manageOrders = "manageOrders",
  managePayments = "managePayments",
  markOrdersUncollectible = "markOrdersUncollectible",
  viewPeople = "viewPeople",
  viewSection = "viewSection",
  managePeople = "managePeople",
  viewFacilities = "viewFacilities",
  createFacilities = "createFacilities",
  manageFacilities = "manageFacilities",
  editFacilitySection = "editFacilitySection",
  manageVideos = "manageVideos",
  manageUniversities = "manageUniversities",
  viewPeopleInteractions = "viewPeopleInteractions",
  managePeopleInteractions = "managePeopleInteractions",
  manageEvents = "manageEvents",
  managePAT = "managePAT",
  editPAT = "editPAT",
  manageRecruitmentActivities = "manageRecruitmentActivities",
  managePATActivities = "managePATActivities",
  manageNationalActivities = "manageNationalActivities",
  manageChampionshipActivities = "manageChampionshipActivities",
  manageEducationActivities = "manageEducationActivities",
  manageEducationPrograms = "manageEducationPrograms",
  viewJobPosts = "viewJobPosts",
  viewJobPostDetails = "viewJobPostDetails",
  manageJobPosts = "manageJobPosts",
  viewDuesRate = "viewDuesRate",
  manageDuesRates = "manageDuesRates",
  editSSN = "editSSN",
  editDOB = "editDOB",
  editLastName = "editLastName",
  manageParticipations = "manageParticipations",
  manageLegacyPdrCredits = "manageLegacyPdrCredits",
  viewCareerPreferences = "viewCareerPreferences",
  viewCareerPlan = "viewCareerPlan",
  manageCareerPlan = "manageCareerPlan",
  viewCompensationProfiles = "viewCompensationProfiles",
  manageCompensationProfiles = "manageCompensationProfiles",
  manageCareerPreferences = "manageCareerPreferences",
  manageFacilityRoles = "manageFacilityRoles",
  viewRecruitingEventRecaps = "viewRecruitingEventRecaps",
  manageEmployments = "manageEmployments",
  manageNonMemberEmployments = "manageNonMemberEmployments",
  manageMemberBands = "manageMemberBands",
  deleteMemberBands = "deleteMemberBands",
  manageChapters = "manageChapters",
  manageSuspensions = "manageSuspensions",
  manageSuspensionsRestricted = "manageSuspensionsRestricted",
  manageRecruitmentLeads = "manageRecruitmentLeads",
  editEmail = "editEmail",
  viewTasks = "viewTasks",
  manageTasks = "manageTasks",
  manageApplications = "manageApplications",
  viewCommittees = "viewCommittees",
  manageCommittees = "manageCommittees",
  manageMergePurge = "manageMergePurge",
  viewBeneficiaries = "viewBeneficiaries",
  manageBeneficiaries = "manageBeneficiaries",
  manageOwnUniversity = "manageOwnUniversity",
  assumeUser = "assumeUser"
}

export enum DOMAIN {
  GRP = "benefit_programs",
  EDUCATION = "education",
  BENEFIT_PROGRAMS = "benefit_programs",
  SECTIONS = "sections",
  COMMERCE = "commerce",
  PEOPLE = "people",
  FACILITIES = "facilities",
  EVERYONE = "EVERYONE",
  JOBS = "jobs",
  UNIVERSITIES = "universities",
  EVENTS = "events",
  TASKS = "tasks"
}

export interface Capability {
  domains: DOMAIN[];
  permissions: PERMISSION[];
}

export enum ROLE {
  // Staff Department Roles
  CAREER_SERVICES_STAFF = "career_services_staff",
  RECRUITING_STAFF = "recruiting_staff",
  EDUCATION_STAFF = "education_staff",
  FINANCE_STAFF = "finance_staff",
  MEMBERSHIP_SERVICES_STAFF = "membership_services_staff",
  PLAYER_ENGAGEMENT_STAFF = "player_engagement_staff",
  SECTION_STAFF = "section_staff",
  TECHNOLOGY_STAFF = "technology_staff",
  UNIVERSITY_STAFF = "university_staff",

  // Additional Elevated Roles
  CAREER_SERVICES_ADMIN = "career_services_admin",
  EDUCATION_ADMIN = "education_admin",
  FINANCE_ADMIN = "finance_admin",
  MEMBERSHIP_SERVICES_ADMIN = "membership_services_admin",
  SECTION_ADMIN = "section_admin",
  HQ_STAFF = "hq_staff",

  // All-Permission Role
  GLOBAL_ADMIN = "global_admin",

  // Single - Permission Roles
  CRM_FULL_DOB = "crm_full_dob",
  CRM_FULL_SSN = "crm_full_ssn"
}
